import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const roomAreaTagManager = createRangeTagManager({
  jsonQueryKey: 'room_area',
  template: 'Площадь комнаты %s м²',
  id: 'roomArea',
});
